import { render } from "./CertificationsSection.vue?vue&type=template&id=1b1eb3b4&scoped=true"
import script from "./CertificationsSection.vue?vue&type=script&lang=js"
export * from "./CertificationsSection.vue?vue&type=script&lang=js"

import "./CertificationsSection.vue?vue&type=style&index=0&id=1b1eb3b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1eb3b4"]])

export default __exports__